<template>
    <div>
        <div @click="toggle" class="accordion" :class="{ 'active': show, 'accordion--minimal': minimal === '' }">
        <slot name="label"></slot>
        </div>
        <div class="panel" :class="{ 'show': show && noPanel !== '', 'panel--minimal': minimal === '' }">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Accordion",
        props: ['minimal', 'active', 'noPanel'],
        data() {
            return {
                show: this.active === ''
            };
        },
        methods: {
            toggle() {
                this.show = !this.show;
                this.$emit(this.show ? 'opened' : 'closed');
            }
        }
    }
</script>

<style scoped>
    .accordion {
        border: 2px solid #ECEFF4;
        background-color: white;
        cursor: pointer;
        padding: 14px;
        width: 100%;
        text-align: left;
        outline: none;
        transition: 0.4s;
        margin-bottom: 10px;
    }
    .accordion--minimal {
      border:0;
      border-top-width: 1px;
      border-top-style: solid;
      border-top-color: #ECEFF4;
      color: #3847B6;
    }
    .active, .accordion:hover {
        background-color: #f7f9fc;
    }
    .panel {
        padding: 18px 18px;
        border: 2px solid #ECEFF4;
        background-color: white;
        display: none;
        overflow: hidden;
        transition: max-height 0.2s ease-out;
        font-size: 18px;
        font-weight: 300;
        margin-bottom: 10px;
    }
    .panel--minimal {
      border:0;
      overflow: visible;
    }
    .accordion:after {
        content: '\02795';
        font-size: 13px;
        color: #777;
        float: right;
        margin-left: 5px;
        margin-top:5px;
    }
    .active:after {
        content: "\2796";
    }
    .show {
        display: block;
    }
</style>
